import React, {Component, PropTypes} from "react";
import {inject, observer} from 'mobx-react';
import * as mobx from 'mobx';
import {WeaForm} from 'comsMobx';
import {Modal, message} from "antd";
import {WeaScroll,WeaDialog} from 'ecCom'
import FavDirBar from "./FavDirBar";
import FavDirTree from "./FavDirTree";
import "../../style/index.css";
import SearchFavourite from "../../util/SearchFavourite";
let form = new WeaForm()
@inject("favouriteDialogStore")
@inject("favouriteBrowserStore")
@inject("sysFavouriteStore")
@inject("favouriteDirStore")
@inject("myFavouriteStore")


@observer
export default class FavouriteDir extends Component {
    constructor(props){
        super(props)
        this.state={
            visible:true
        }
    }
    onTreeNodeSelect = (nodeid) => {
        let {favouriteDirStore, sysFavouriteStore} = this.props;
        if (nodeid.indexOf("add") == -1 && nodeid.indexOf("edit") == -1) {    //非编辑状态下
            /**
             * 记录下选中的节点
             */
            favouriteDirStore.selectTreeNode(nodeid);
            /**
             * 选中树节点后，刷新收藏的列表
             */
            let isinit = true;
            let isreload = false;
            SearchFavourite.setConditions({dirId: nodeid});
            let searchFavourite = new SearchFavourite(sysFavouriteStore);
            searchFavourite.load({isinit, isreload});
        }
    }

    render() {
        let {
            myfavResultStore,
            favouriteDialogStore,
            favouriteBrowserStore,
            sysFavouriteStore,
            favouriteDirStore,
            myFavouriteStore
        } = this.props;

        let stores = {
            myfavResultStore,
            favouriteDialogStore,
            favouriteBrowserStore,
            sysFavouriteStore,
            favouriteDirStore,
            myFavouriteStore
        };
        let {treeData} = favouriteDirStore;
        treeData = mobx.toJS(treeData);
        return (
            
            <div className={this.props.changename=='fullPagetreeLeft'?'fullPagetreeLeft':'fav-left'}>
                <FavDirBar {...stores}/>
                <div className="fav-left-tree">
                    <WeaScroll className="sysfav-scroll-wrapper" typeClass="scrollbar-macosx" style={{"width": "100%"}}>
                        <FavDirTree  {...stores} onSelect={this.onTreeNodeSelect}/> 
                    </WeaScroll>
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ../src4js/pc4mobx/favourite/components/dir/index.js